<h2 mat-dialog-title>Session is about to expire</h2>

<mat-dialog-content> You will be logged out in {{ countDown$ | async }} seconds </mat-dialog-content>

<mat-dialog-actions>
	<button mat-stroked-button [mat-dialog-close]="true">Continue</button>
</mat-dialog-actions>
